export const ON_CHANGE = Symbol("Reactive");
